import FilterIcon from '../../../../Assets/icons/filter.svg'
import CloseIcon from '../../../../Assets/icons/cross-gray.svg'
import { useState } from 'react'
import CostFilter from './CostFilter/CostFilter'
import LocationFilter from './LocationFilter/LocationFilter'
import { useSelector } from 'react-redux'

function OrganizationFilter({

    selectedDivision, setSelectedDivision,
    selectedDistrict, setSelectedDistrict,
    selectedArea, setSelectedArea,
    divisions, districts, areas,

    selectedCost, setSelectedCost,

    filterShow, handleFilterHide

}) {

    const [showLocationFilter, setShowLocationFilter] = useState(false)
    const [showCostFilter, setShowCostFilter] = useState(false)

    const {consumer} = useSelector(state => state.auth)

    return (
        <div className={`col left ${filterShow ? 'show' : ''}`}>
            <div className="filter_wrapper">
                <div className="filter_header">
                    <div>
                        <h4>
                            <img src={FilterIcon} alt="icon" />
                            {
                                consumer
                                ?
                                    consumer.language === 'english'
                                    ?
                                        'Filter'
                                    :
                                        'ফিল্টার করুন'
                                :
                                    'ফিল্টার করুন'
                            }
                        </h4>
                    </div>
                    <div>
                        <img src={CloseIcon} alt="icon" onClick={handleFilterHide} />
                    </div>
                </div>

                <div className="filter_category_wrapper">

                    <LocationFilter

                        showLocationFilter={showLocationFilter}
                        setShowLocationFilter={setShowLocationFilter}
                        setShowCostFilter={setShowCostFilter}
                        selectedDivision={selectedDivision}
                        setSelectedDivision={setSelectedDivision}
                        selectedDistrict={selectedDistrict}
                        setSelectedDistrict={setSelectedDistrict}
                        selectedArea={selectedArea}
                        setSelectedArea={setSelectedArea}
                        divisions={divisions}
                        districts={districts}
                        areas={areas}
                        consumer={consumer}

                    />

                    <CostFilter

                        showCostFilter={showCostFilter}
                        setShowCostFilter={setShowCostFilter}
                        setShowLocationFilter={setShowLocationFilter}

                        selectedCost={selectedCost}
                        setSelectedCost={setSelectedCost}
                        consumer={consumer}

                    />

                </div>
            </div>
        </div>
    )
}

export default OrganizationFilter